// WeekRecap.jsx — короткое интро кат-сцены итогов недели.
// Только корона + титул + даты (~2.3с), затем закрывается и управление
// передаётся UsersList, который продолжает анимацию уже на реальном
// weekly-списке (spotlight по строкам).

import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Lottie } from "lottie-react";
import { useTheme } from "./useTheme";
import crownLottie from "./golden_crown.json";

function formatDateRange(ws, we) {
  const months = ["янв", "фев", "мар", "апр", "мая", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"];
  try {
    const start = new Date(ws + "T00:00:00");
    const end = new Date(we + "T00:00:00");
    end.setDate(end.getDate() - 1);
    return `${start.getDate()} ${months[start.getMonth()]} — ${end.getDate()} ${months[end.getMonth()]}`;
  } catch {
    return `${ws} — ${we}`;
  }
}

const INTRO_FADE_MS = 300;
const CROWN_HOLD_MS = 2300;   // Lottie = 2.5s, даём ей доиграть
const OUTRO_FADE_MS = 300;

export default function WeekRecap({ data, onDone }) {
  const { isDark } = useTheme();
  const closedRef = useRef(false);
  const timeoutsRef = useRef([]);

  useEffect(() => {
    const schedule = (ms, cb) => {
      const t = setTimeout(cb, ms);
      timeoutsRef.current.push(t);
    };
    schedule(INTRO_FADE_MS + CROWN_HOLD_MS + OUTRO_FADE_MS, () => {
      if (!closedRef.current) {
        closedRef.current = true;
        onDone?.();
      }
    });
    return () => timeoutsRef.current.forEach(clearTimeout);
  }, [onDone]);

  const skip = (e) => {
    if (e) e.stopPropagation();
    if (closedRef.current) return;
    closedRef.current = true;
    onDone?.();
  };

  const dateRange = formatDateRange(data.week_start, data.week_end);
  const overlayBg = `rgba(10,12,20,${isDark ? 0.9 : 0.84})`;

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center"
      style={{
        background: overlayBg,
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        animation: `recapIntroFade ${INTRO_FADE_MS}ms ease both, recapIntroFadeOut ${OUTRO_FADE_MS}ms ease ${INTRO_FADE_MS + CROWN_HOLD_MS}ms both`,
      }}
      onClick={skip}
      role="dialog"
      aria-label="Итоги недели"
    >
      <style>{`
        @keyframes recapIntroFade { from { opacity: 0 } to { opacity: 1 } }
        @keyframes recapIntroFadeOut { from { opacity: 1 } to { opacity: 0 } }
        @keyframes recapTitleIn { from { opacity: 0; transform: translateY(-6px) } to { opacity: 1; transform: translateY(0) } }
      `}</style>

      <div className="flex flex-col items-center gap-4 px-6" onClick={(e) => e.stopPropagation()}>
        <div className="text-center" style={{ animation: `recapTitleIn 500ms ease ${INTRO_FADE_MS}ms both` }}>
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400">Неделя закрыта</p>
          <p className="text-[16px] font-semibold text-white mt-0.5">{dateRange}</p>
        </div>
        <div
          style={{
            width: 180,
            height: 180,
            filter: "drop-shadow(0 0 24px rgba(251,191,36,0.55))",
          }}
        >
          <Lottie
            src={crownLottie}
            loop={false}
            autoplay
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}
